import {DownloadFileInfo, UploadFileInfo} from "@interfaces/panel/files";
import { GetFilesModel, UploadFileDoneModel } from "@models/panel";
import IService from "./iService";

export default class FilesService extends IService {

    async finishFileUploading (file: UploadFileDoneModel) {
        return await this.putApi<DownloadFileInfo>('/api/storage/files/', file);
    }

    async failFileUploading (file: UploadFileInfo) {
        return await this.postApi('/api/storage/files/failed/', file);
    }
    
    async getFiles(fileIds: string[]) {
        return await this.postApi<DownloadFileInfo[]>('/api/storage/files/', {
            fileIds
        } as GetFilesModel);
    }
}